module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Unpin_16"],"path":[{"$":{"d":"M13.69,11,2.69,0H13.5A2.68,2.68,0,0,1,13,1.35,3.45,3.45,0,0,1,12,2V8.49a4.26,4.26,0,0,1,1.65,1,2,2,0,0,1,.72,1.5ZM4,6.69V8.49a4.26,4.26,0,0,0-1.65,1A2,2,0,0,0,1.64,11H6.87L8,16l1-4.31ZM8,16v0ZM16,15.25,11.71,11,4,3.29.77.06.06.77,4,4.71,10.29,11l5,5h0Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Unpin_16.svg
// module id = d8pf
// module chunks = 1